<script>
export default {
  name: "main-page",
};
</script>

<template>
  <div>
    <h2 style="margin-inline: auto; text-align: center; max-width: 600px">
      Сервис предназначен для добавления пунктов приема вторичного сырья
    </h2>
  </div>
</template>

<style scoped></style>
